import React from 'react'
import Select from '@mui/material/Select'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

const AdxDropdown = ({
  label,
  value,
  onChange,
  sx,
  sxLabel,
  sxDropdown,
  errorMessage,
  children,
  disabled,
  isErrorShown,
  menuPropsSx,
  icon,
  ...rest
}) => {
  const { componentHeight, palette } = useTheme()

  const { name } = rest
  return (
    <Box sx={{ ...sx }}>
      <Box display={'flex'} flexDirection={'column'} rowGap={label ? 1 : null}>
        {label ? (
          <Typography variant="body1" sx={{ ...sxLabel }}>
            {label}
          </Typography>
        ) : null}
        <Select
          name={name}
          color="alternate"
          value={value}
          onChange={onChange}
          IconComponent={icon ? icon : KeyboardArrowDownIcon}
          disabled={disabled}
          MenuProps={{
            sx: {
              '&.MuiMenu-root': {
                maxHeight: '440px',
              },
              ...menuPropsSx,
            },
            autoFocus: true,
          }}
          sx={{
            outlineColor: isErrorShown ? palette.error.main : null,
            bgcolor: 'background.main',
            height: componentHeight.standard,
            border: '1px solid',
            borderColor: 'gray-line.main',
            borderRadius: '4.5px',
            '& .MuiOutlinedInput-notchedOutline': {
              borderWidth: 0,
            },
            '&.Mui-disabled': {
              backgroundColor: 'gray-background.main',
              color: '#FFFFFF',
              '& .MuiSelect-icon': {
                color: 'light-gray-text-2.main',
              },
            },
            '&.Mui-focused': {
              '& .MuiOutlinedInput-notchedOutline': {
                borderWidth: 0,
              },
              outlineColor: 'primary.main',
            },
            ...sxDropdown,
          }}
          {...rest}
        >
          {children}
        </Select>
      </Box>
      <Box pt={0.5}>{isErrorShown && errorMessage}</Box>
    </Box>
  )
}

export default AdxDropdown
